import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { View } from 'react-native';
import { component, ParagraphView, BaseScreenComponent } from '@serviceos-rn/core';
import { TipConfig } from '../../../TipConfig';
import { TipRoutes } from '../../Coordinator/TipRoutes';
import { ITipScreenViewModelType } from './ITipScreenViewModel';
import { TipConfiguration } from '../../../Domain/DTOs/TipConfigurationDTO';
import { OptionsView } from '../../Components/Options/OptionsView';
import { useTipHeight } from '../../Hooks/UseTipHeight';
export const CompactTipScreenComponent = component({
    provider: TipConfig.provider,
    moduleName: TipConfig.moduleName,
    componentName: TipConfiguration.ComponentNames.compactTipScreen,
    dependencies: {
        viewModel: ITipScreenViewModelType
    },
    style(theme, mediaQuery, window, props) {
        return {
            container: {
                flex: 1,
                alignItems: 'center'
            },
            root: Object.assign({ padding: 16, paddingTop: 25, width: '100%', height: '100%' }, mediaQuery.md({
                maxWidth: 500
            })),
            header: {
                padding: 10
            },
            body: {},
            title: {
                marginBottom: 10
            },
            message: {
                fontSize: 14,
                marginBottom: 0
            },
        };
    }
})(({ style, viewModel, navigation, route }) => {
    var _a;
    const [_, setHeight] = useTipHeight((route === null || route === void 0 ? void 0 : route.name) || TipRoutes.TipCompact);
    const handleLaylout = useCallback((e) => setHeight(e.nativeEvent.layout.height), []);
    return (_jsx(BaseScreenComponent, { navigation: navigation, loading: viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.loading, onErrorDismiss: viewModel === null || viewModel === void 0 ? void 0 : viewModel.onErrorDismiss, errorPopUp: viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.error, hideHeader: true, children: _jsx(View, { style: style === null || style === void 0 ? void 0 : style.container, onLayout: handleLaylout, children: _jsxs(View, { style: style === null || style === void 0 ? void 0 : style.root, children: [_jsx(View, { style: style === null || style === void 0 ? void 0 : style.header, children: _jsx(ParagraphView, { textStyle: style === null || style === void 0 ? void 0 : style.message, children: (_a = viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.tipOptions) === null || _a === void 0 ? void 0 : _a.title }) }), _jsx(View, { style: style === null || style === void 0 ? void 0 : style.body, children: _jsx(OptionsView, { tipOptions: viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.tipOptions, mode: "compact", onChange: viewModel === null || viewModel === void 0 ? void 0 : viewModel.onChange }) })] }) }) }));
});
